import { render, staticRenderFns } from "./CountUp.vue?vue&type=template&id=47c9b3d3"
import script from "./CountUp.vue?vue&type=script&lang=js"
export * from "./CountUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports